// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { uiStateActions as actions } from '.';

// function* doSomething() {}

export function* uiStateSaga() {
  // yield takeLatest(actions.someAction.type, doSomething);
}
